var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-badge',{attrs:{"variant":_vm.variant}},[_c('span',{staticClass:"badge-count"},[_vm._v(" "+_vm._s(_vm.count)+" ")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }